import type { ChangeEventHandler } from 'react'
import { cn } from '~/utils/cn'

const SelectBox: FCC<{
	name: string
	label?: string
	onChange?: ChangeEventHandler<HTMLSelectElement>
	value?: string | number
	required?: boolean
	defaultValue?: string | number | readonly string[] | undefined
}> = (props) => {
	const {
		label,
		name,
		value,
		onChange,
		defaultValue,
		children,
		required = false,
	} = props

	return (
		<span className={cn(label && 'grid grid-cols-1 gap-2')}>
			{label ? (
				<label
					htmlFor={name}
					className="select-none"
				>
					{label}
					{' '}
					{required ? <span className="text-red-600">*</span> : null}
				</label>
			) : null}
			<select
				className="text-2xl rounded-sm bg-gray-900 px-1 mx-1 border-zephyr-blue border-2 cursor-pointer focus:outline-hidden"
				name={name}
				id={name}
				onChange={onChange}
				value={value}
				defaultValue={defaultValue}
			>
				{children}
			</select>
		</span>
	)
}

export default SelectBox
